import { useContext } from "react";

import { TrackerContext } from "./TrackerContext";

const useTracker = () => {
  const context = useContext(TrackerContext);
  if (context === null) {
    throw new Error("TrackerContext context cannot be null");
  }
  return context;
};

export default useTracker;
